<div class="title mb-4">
  <h1>{{ 'help.title' | translate }}</h1>
  <h4>{{ 'help.sub_title' | translate }}</h4>
</div>

<div class="main-outer-div flex-grow-1 flex-shrink-1 pt-4">


  <div class="left">
    <div class="white-box">

      <div class="form-steps-container-title">

        <div class="form-steps-title-section-row-1">
          <div class="form-steps-title-section-left">
            <div class="section-title" style="margin-right: 10px">
              {{'help.formStep.title'|translate}}
            </div>

          </div>
        </div>
      </div>
      <div class="d-flex flex-column " style="float: right; width: 100%">

        <ng-container *ngFor="let title of titles;let i = index">
          <div [ngClass]="{'selectedSection': scrolled == i}">
            <div (click)="scroll(idNames[i])" [id]="idNames[i]+'button'"
                 class="form-steps-list-row">
              <div class=" form-steps-list-items">
                <ng-container *ngTemplateOutlet="scrolled == i ? selectedCircle : emptyCircle"></ng-container>
                <span class="progress-bar-text">{{ 'help.formStep.' + idNames[i] | translate }}</span>
              </div>
            </div>
            <div class="vertical-line" *ngIf="i < 2"></div>
          </div>
        </ng-container>
      </div>

      <div class="bottom-padding"></div>
    </div>

    <div class="your-data">
      <app-contact-support-help></app-contact-support-help>
    </div>

  </div>



  <div #rightPart id="rightPart" class="right" (scroll)="onWindowScroll()">
    <div class="form-outer-container" id="step1" data-section="1">
      <div class="form-inner-container">
        <app-videos-help></app-videos-help>
      </div>
    </div>
    <div class="form-outer-container" id="step2" data-section="2">
      <div class="form-inner-container">
        <app-release-notes-help></app-release-notes-help>
      </div>
    </div>
    <div class="form-outer-container" id="step3" data-section="3">
      <div class="form-inner-container">
        <app-faq-help></app-faq-help>
      </div>
    </div>
  </div>

  <script src="https://player.vimeo.com/api/player.js" integrity="23d8557a27e6e42b55fdacbe7adfe0fe6408132ebbdf6c36563ac49e0c8c6c02" crossorigin="anonymous"></script>
</div>

<ng-template #emptyCircle><span class="circle">
                  </span></ng-template>

<ng-template #selectedCircle><span class="circle selected-circle">
                  </span></ng-template>
